import React from 'react';
import { FiHeart, FiShield, FiTrendingUp } from 'react-icons/fi';
import { Seo } from '../components/Seo';
import { site } from '../config/site';
import { Icon } from '../components/ui/Icon';

export default function AboutPage() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: `${site.name} — À propos`,
    url: `${site.url}/a-propos`,
    inLanguage: 'fr-FR',
  };

  return (
    <>
      <Seo
        title="À propos"
        description="Pourquoi LuckyBetFR existe: rendre les offres de paris sportifs en France plus lisibles, plus comparables, et plus sûres."
        canonicalPath="/a-propos"
        jsonLd={jsonLd}
      />

      <section className="lbf-container py-12 sm:py-16">
        <h1 className="text-3xl font-black tracking-tight text-white sm:text-4xl">À propos</h1>
        <p className="mt-4 max-w-3xl text-sm text-zinc-200/85">
          LuckyBetFR est un site d’analyse: on décortique les offres de paris sportifs en France avec une logique simple.
          Une offre n’est pas “bonne” parce qu’elle a un gros chiffre. Elle est bonne si elle colle à ton profil, si ses
          conditions sont lisibles, et si la sortie (retrait) est claire.
        </p>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          <div className="lbf-card p-6">
            <div className="flex items-center gap-2 text-sm font-extrabold text-white">
              <Icon icon={FiShield} aria-hidden="true" />
              Clarté
            </div>
            <p className="mt-3 text-sm text-zinc-200/85">
              On met le projecteur sur les conditions: turnover, limites, délais, méthodes.
            </p>
          </div>
          <div className="lbf-card p-6">
            <div className="flex items-center gap-2 text-sm font-extrabold text-white">
              <Icon icon={FiTrendingUp} aria-hidden="true" />
              Comparaison utile
            </div>
            <p className="mt-3 text-sm text-zinc-200/85">
              Graphiques légers, checklists et comparatif: tu vois vite où tu mets les pieds.
            </p>
          </div>
          <div className="lbf-card p-6">
            <div className="flex items-center gap-2 text-sm font-extrabold text-white">
              <Icon icon={FiHeart} aria-hidden="true" />
              Jeu responsable
            </div>
            <p className="mt-3 text-sm text-zinc-200/85">
              Le meilleur pari, c’est celui que tu peux assumer. Budget, limites, pauses: on le rappelle sans te juger.
            </p>
          </div>
        </div>

        <div className="mt-10 lbf-card p-6">
          <h2 className="text-xl font-black text-white">Notre promesse</h2>
          <ul className="mt-4 grid gap-2 text-sm text-zinc-200/85">
            <li>- Écrire en français clair, sans slogans creux.</li>
            <li>- Donner des repères de confiance (retraits, KYC, conditions).</li>
            <li>- Garder le site rapide: design dark, peu de JS, animations légères.</li>
          </ul>
        </div>
      </section>
    </>
  );
}


